<template>
  <div
    class="sm-hint-wrap"
    @mouseenter="enter"
    @mouseleave="leave"
  >
    <slot name="content" />
    <hint-block 
      v-if="showHint"
      :class="{
        'left': left,
        'horizontal': horizontal
      }"
    >
      <template slot="hintContent">
        <span v-html="html"></span>
      </template>
    </hint-block>
  </div>
</template>

<script>
import Hint from '@/components/Hint'

export default {
  name: 'hint-wrap',
  components: {
    'hint-block': Hint
  },
  props: {
    text: {
      type: String,
      default: ''
    },
    left: {
      type: Boolean,
      default: false
    },
    horizontal: {
      type: Boolean,
      default: false
    },
    delay: {
      type: Number,
      default: 500
    },
  },
  data() {
    return {
      showHint: false,
      timer: null,
      // delay: 500
    };
  },
  computed: {
    html() {
      // return this.text.replace(new RegExp('\n', 'g'), '<br />');
      return this.text;
    }
  },
  methods: {
    enter() {
      this.timer = setTimeout(() => this.showHint = true, this.delay);
    },
    leave() {
      this.showHint = false;
      clearTimeout(this.timer);
    }
  }
}
</script>